import styled from 'styled-components';

import { StyledLoader } from '../../styled';

export const StyledNewLoader = styled(StyledLoader)`
  position: absolute;
`;

export const StyledTableContainer = styled.section`
  background-color: transparent;
  border-radius: 0;
  width: 100%;

  & > h4 {
    font-family: var(--tol-font-ui);
    font-style: normal;
    font-weight: 500;
    font-size: 16px;
    line-height: 26px;
    color: ${({ theme }) => theme.textFaint};
    margin-bottom: 30px;
  }
`;

export const StyledContainer = styled.div`
  box-sizing: border-box;
  border-radius: 15px;
`;

export const StyledFallbackSvg = styled.div`
  @media only screen and (max-width: 991px) {
    svg {
      width: 100%;
    }
  }
`;
